module.exports = __webpack_public_path__ + "img/verticalSpacingWhite.e0aaea79.svg";